import React from 'react';
import { Icon, Button } from '@scuf/common';
import './GenericPage.scss';
import { useHistory } from 'react-router-dom';

export default function GenericPage({message}: {message: string}) {
  let history = useHistory();
  return (
    <div className="un-authorized-container">
      <div className="un-authorized">
        <Icon name="badge-warning" size="xlarge" />
        <h1 id="headerPageNotFound">{message}</h1>
        <Button
          className="routeToHomeButton"
          onClick={() => history.push('/')}
          type="secondary"
          content="Return to landing page."
        />
      </div>
    </div>
  );
}
